import styled, { css } from "styled-components/macro";
import {
  medBlue,
  darkGrey,
  lightGrey,
  darkModeCardBackgroundColor,
  darkModeTextColor,
  darkModeBackgroundHoveredColor,
  flGeneralBorder,
} from "../../../../constants/colors";
import { BREAKPOINT_DESKTOP_XL } from "constants/constants";

export const SingleCustomerTileStyles = styled.div<{
  $isDarkMode: boolean;
  $isLastSelected: boolean;
}>`
  position: relative;
  button.customerTileButton {
    text-align: left !important;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 64px;
    width: 200px;
    padding: 1em 1.5em !important;
    border: 1px solid ${medBlue} !important;
    box-sizing: border-box !important;
    background-color: ${({ $isDarkMode }) =>
      $isDarkMode ? darkModeCardBackgroundColor : "white"} !important;
    position: relative !important;
    .multi-work-schedules-indicator {
      position: absolute;
      z-index: -1;
      top: 3px;
      left: 3px;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      border: 1px solid ${medBlue} !important;
      &:after {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        top: 1px;
        left: 1px;
        border: 1px solid ${medBlue} !important;
      }
    }
    border-radius: 0px !important;
    text-transform: none !important;
    margin: 2px !important;
    font-size: 0.675rem !important;
    @media (min-width: ${BREAKPOINT_DESKTOP_XL}px) {
      font-size: 2.2rem !important;
      width: 640px;
      height: 164px;
    }
    &:hover {
      background-color: ${({ $isDarkMode }) =>
        $isDarkMode ? darkModeBackgroundHoveredColor : lightGrey} !important;
    }
    ${({ $isLastSelected }) =>
      $isLastSelected &&
      css`
        outline: 2px dashed ${flGeneralBorder};
      `}
  }
  .top-group-title {
    font-weight: 600;
    width: 100%;
    line-height: 1.2em;
    font-size: 1.2em !important;
    color: ${({ $isDarkMode }) =>
      $isDarkMode ? darkModeTextColor : darkGrey} !important;
  }
  .top-group-subtitle {
    line-height: 1.2em;
    font-size: 0.8em !important;
    font-weight: 500;
    height: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${({ $isDarkMode }) =>
      $isDarkMode ? darkModeTextColor : darkGrey} !important;
    pointer-events: none;
  }
`;
